import { InputBase, Password, Search, TextArea } from "./Input";

/** `Input.TextArea`, `Input.Password`, `Input.Search` wie bei Antd; eigene Datei wegen Fast Refresh. */
export const Input = Object.assign(InputBase, { TextArea, Password, Search });
